import React, { useMemo } from 'react';
import { htmlToText, sanitizeHtml } from 'utils/StringUtils';

interface IHtmlRendererProps extends Omit<React.HTMLProps<{}>, 'children'> {
  /**
   * Specifies custom tag name
   * @default 'div'
   */
  component?: string;
  /**
   * Html that should be rendered
   */
  html: string;
  /**
   * Render mode determines how to render provided @param html
   * @default html
   */
  mode?: 'html' | 'plain-text';
}

/**
 *  Component renders give html in a safe way to prevent XSS-injections.
 *
 * Copyright (c) 2022 Decisions All Rights Reserved
 */
export function HtmlRenderer({ component, html, mode = 'html', ...otherProps }: IHtmlRendererProps) {
  const safeHtml = useMemo(() => {
    if (mode === 'html') {
      return sanitizeHtml(html);
    } else {
      return htmlToText(html) ?? '';
    }
  }, [html, mode]);
  const Root = component ?? 'div';
  const props: React.HTMLProps<{}> = {
    ...otherProps,
    dangerouslySetInnerHTML: { __html: safeHtml },
  };

  return <Root {...props} />;
}
